import { FieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

import Spinner from 'components/Shared/Spinner';

import { FormNavigationStep, NAV_STEP_ATTRIBUTE } from '../../constants/formNavigation';
import { useFormState } from '../../contexts/FormState/FormStateContext';
import { ButtonViewModel } from '../../types/button';

const TspSubmitButton: React.FC<FieldProps<ButtonViewModel>> = ({ field, onButtonClick }) => {
  const { busyButtonId } = useFormState();
  const { id, name } = field.buttonField;
  const isButtonBusy = id === busyButtonId;
  const navStep = field.navigationStepField.value;
  const isPreviousButton = navStep === FormNavigationStep.Previous;

  return (
    <button
      type="submit"
      formNoValidate={isPreviousButton}
      id={id}
      name={name}
      value={field.model.title}
      {...{ [NAV_STEP_ATTRIBUTE]: navStep }}
      className={classNames(
        'tsp-action-button',
        isPreviousButton ? 'tsp-action-button--secondary' : 'tsp-action-button--primary'
      )}
      onClick={() => onButtonClick(name)}
    >
      {isButtonBusy ? <Spinner /> : <span>{field.model.title}</span>}
    </button>
  );
};

export default TspSubmitButton;
